<template>
  <QuesCard :maxwidth="maxwidth" :ques="ques" :showIsAssign="true">
    <template slot="title">
      {{ ques.serial == null ? '' : ques.serial + '. ' }}日期時間題
    </template>
    <v-card-text class="text-start" slot="content">
      <div v-for="(name, idx) in ques.cnName.split(/\r?\n/)" :key="idx" class="blod quest_topic">{{ name }}</div>
      <div v-if="ques.questHeadingPic" class="text-center">
        <img
          v-bind:src="$store.state.server + ques.questHeadingPic"
          style="max-width: 100%;"
        />
      </div>
      <v-dialog
        ref="dialog"
        v-model="modal"
        :return-value.sync="ques.value"
        persistent
        width="290px"
      >
        <template v-slot:activator="{ on }">
          <v-text-field
            v-model="ques.value"
            prepend-icon="event"
            readonly
            v-on="on"
            class="peter-text"
            :rules="[
              v => {
                let pass = !(ques.isRequired && !ques.value)
                return pass ? true : '此題為必填'
              },
              v => {
                let pass =
                  /[0-9]{4}-[0-9]{2}-[0-9]{2} [0-9]{2}:[0-9]{2}/.test(ques.value) ||
                  !ques.value ||
                  ques.value.length === 0
                return pass ? true : '日期時間格式錯誤'
              }
            ]"
          ></v-text-field>
        </template>
        <v-date-picker
          v-show="selectingDate"
          v-model="date"
          scrollable
          @change="dateSelected()"
        >
        </v-date-picker>
        <v-time-picker v-show="!selectingDate" v-model="time" scrollable>
          <v-spacer></v-spacer>
          <v-btn text color="primary" @click="modal = false">Cancel</v-btn>
          <v-btn text color="primary" @click="timeSelected()">OK</v-btn>
        </v-time-picker>
      </v-dialog>
    </v-card-text>
  </QuesCard>
</template>

<script>
import QuesCard from './QuesCard'
export default {
  components: {
    QuesCard
  },
  props: {
    maxwidth: {
      type: Number,
      default: null
    },
    ques: {
      type: Object,
      default: null
    }
  },
  // 監聽日期、時間變化時即時更新到 ques.value
  watch: {
    date(newValue, oldValue) {
      this.ques.value = this.date + ' ' + this.time
    },
    time(newValue, oldValue) {
      this.ques.value = this.date + ' ' + this.time
    }
  },
  data() {
    return {
      modal: false, // dialog 是否出現
      selectingDate: true, // selectingDate 決定 dialog 要顯示 date-picker(true) 或 time-picker(false)
      date: '', // datepicker  bind value
      time: '' // timepicker bind value
    }
  },
  methods: {
    // 當日期被選中時的動作
    dateSelected() {
      this.selectingDate = false // 切換為顯示 date-picker
    },
    // 當時間被選中時的動作
    timeSelected() {
      this.selectingDate = true // 切換為顯示 time-picker
      this.$refs.dialog.save(this.ques.value) // 收起 dialog
    }
  }
}
</script>

<style lang="scss" scoped></style>
